import { Moment } from 'moment';
import { ITicket } from 'app/shared/model//ticket.model';
import { IUser } from './user.model';

export const enum PaymentMethod {
  JETCO = 'JETCO',
  ASIA_PAY = 'ASIA_PAY'
}

export const enum TransactionStatus {
  PAID = 'PAID',
  WAITING = 'WAITING',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
  REJECTED = 'REJECTED'
}

export interface ITransaction {
  id?: number;
  transactionDateTime?: Moment;
  paymentDateTime?: Moment;
  paymentMethod?: PaymentMethod;
  paymentKey?: string;
  amount?: number;
  creditCard?: string;
  status?: TransactionStatus;
  invoiceNo?: string;
  firstName?: string;
  lastName?: string;
  mobile?: string;
  email?: string;
  address?: any;
  qrCode?: string;
  question1?: string;
  answer1?: string;
  question2?: string;
  answer2?: string;
  question3?: string;
  answer3?: string;
  remark?: string;
  tickets?: ITicket[];
  user?: IUser;
}

export const defaultValue: Readonly<ITransaction> = {};
